import { useEffect, useState } from "react";
import SvgFacebook from "@/styles/icons/Facebook";
import SvgInstagram from "@/styles/icons/Instagram";
import SvgTikTok from "@/styles/icons/TikTok";
import SvgYoutube from "@/styles/icons/Youtube";
import Image from "next/image";
import { cn } from "@/lib/utils";
import Link from "../Link";

// Servis za dohvat podataka iz Directusa
async function fetchFooterData() {
  const res = await fetch("/api/footer-data");
  return await res.json();
}

export default function Footer() {
  const [contactInfo, setContactInfo] = useState<any>(null);
  const [officeLocations, setOfficeLocations] = useState<any[]>([]);
  const [footerNavigation, setFooterNavigation] = useState<any[]>([]);

  useEffect(() => {
    fetchFooterData().then((data) => {
      setContactInfo(data.contactInfo);
      setOfficeLocations(data.officeLocations);
      setFooterNavigation(data.footerNavigation);
    });
  }, []);

  if (!contactInfo) return null;

  const getMenuLink = (href) => {
    return window.location.origin + href.replace("{slug}", "");
  };

  return (
		<>
			<div className='px-6 py-12 desktop:px-8'>
				<div className='flex flex-col sm:flex-row  items-center justify-between mb-6'>
					<a href='/'>
						<Image
							src='/Logo-light.svg'
							alt='Solomon Plastic Surgery'
							width={304}
							height={103}
						/>
					</a>
					<div className='flex flex-col items-center md:items-end justify-center h-full'>
						<div className={cn('flex space-x-4 mt-6 md:mt-0')}>
							<a href='https://www.facebook.com/solomonplasticsurgery/'>
								<SvgFacebook className={cn('w-5 h-5', 'md:w-6 md:h-6')} />
							</a>
							<a href='https://www.instagram.com/solomonplasticsurgery/'>
								<SvgInstagram className={cn('w-5 h-5', 'md:w-6 md:h-6')} />
							</a>
							<a href='https://www.tiktok.com/@solomonplasticsurgery'>
								<SvgTikTok className={cn('w-5 h-5', 'md:w-6 md:h-6')} />
							</a>
							<a href='https://www.youtube.com/channel/UC_1kmCifgvaWtu0fGMuwcSg'>
								<SvgYoutube className={cn('w-5 h-5', 'md:w-6 md:h-6')} />
							</a>
						</div>
					</div>
				</div>

				<div
					className={cn(
						'grid gap-8 mb-8 text-left',
						'md:grid-cols-3',
						'desktop:grid-cols-5',
					)}
				>
					<div>
						<h3 className='text-accent-color-two text-footer-title uppercase font-sans mb-3 md:mb-4 desktop:mb-4'>
							{contactInfo.clinic_name}
						</h3>
					</div>

					{officeLocations.map(office => (
						<div key={office.id}>
							<h3 className='text-accent-color-two text-footer-title uppercase font-sans mb-3 md:mb-4 desktop:mb-4'>
								{office.title}
							</h3>
							<div className='text-white '>
								<p className='mb-1 text-span-small'>{office.street}</p>
								<p className='mb-1 text-span-small'>{office.suite}</p>
								<p className='mb-3 text-span-small'>
									{office.city}, {office.state} {office.zip_code},{' '}
									{office.country}
								</p>
							</div>
						</div>
					))}

					<div>
						<h3 className='text-accent-color-two text-footer-title uppercase font-sans mb-3 md:mb-4 desktop:mb-4'>
							PHONE
						</h3>
						<a
							href={contactInfo.phone_href}
							className='text-span-small underline text-white'
						>
							{contactInfo.phone_number}
						</a>
					</div>
					<div>
						<div className='text-sm text-gray-300'>
							<h4 className='text-paragraph-large text-accent-color-two'>
								OFFICE HOURS
							</h4>
							<p className='text-span-small text-white'>
								{contactInfo.office_hours}
							</p>
						</div>
					</div>
				</div>

				<div className='border-t border-accent-color-two pt-6 mb-6'></div>

				<div
					className={cn(
						'grid gap-6 text-left',
						'md:grid-cols-[repeat(5,1fr)]',
						'desktop:grid-cols-[repeat(5,1fr)]',
					)}
				>
					{footerNavigation.map((section: any) => {
						const singleLink =
							section.links.length === 1 ? section.links[0] : null
						return (
							<div key={section.id} className='flex flex-col gap-3'>
								{singleLink ? (
									<a
										href={getMenuLink(singleLink.href)}
										className='font-sans text-accent-color-two text-footer-title uppercase hover:text-secondary-light'
									>
										{section.title}
									</a>
								) : (
									<h3 className='font-sans text-accent-color-two text-footer-title uppercase'>
										{section.title}
									</h3>
								)}
								{!singleLink && (
									<ul className='font-sans flex flex-col gap-3'>
										{section.links.map((link: any) => (
											<li key={link.id}>
												<a
													href={getMenuLink(link.href)}
													className='font-sans text-white text-footer-links hover:text-secondary-light'
												>
													{link.title}
												</a>
											</li>
										))}
									</ul>
								)}
							</div>
						)
					})}
				</div>
			</div>

			<div className='md:hidden fixed bottom-0 left-0 right-0 z-50'>
				<div className='flex w-full '>
					<a
						href={`tel:${contactInfo.phone_number}`}
						className='flex-1 bg-[#E4A43E] text-[#273240] font-sans text-lg font-normal uppercase py-4 px-8 leading-6 text-center min-w-[160px] block tracking-[2.7px]'
					>
						Call Us
					</a>
					<Link
						href='/contact/'
						className='flex-1 bg-[#59697C] text-[#F7F7F7] font-sans text-base font-normal uppercase py-4 px-5 leading-6 text-center block tracking-[1.6px]'
					>
						Book Now
					</Link>
				</div>
			</div>
		</>
	)
}
